import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxPermissionsModule } from "ngx-permissions";

@NgModule({
  exports: [CommonModule, NgxPermissionsModule],
})
export class PermissionsModule {}
